"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildEnvironmentAPIKeyModel = exports.buildEnvironmentModel = void 0;
var util_1 = require("../features/util");
var util_2 = require("../identities/util");
var util_3 = require("../projects/util");
var models_1 = require("./models");
function buildEnvironmentModel(environmentJSON) {
    var project = (0, util_3.buildProjectModel)(environmentJSON.project);
    var featureStates = environmentJSON.feature_states.map(function (fs) {
        return (0, util_1.buildFeatureStateModel)(fs);
    });
    var environmentModel = new models_1.EnvironmentModel(environmentJSON.id, environmentJSON.api_key, project);
    environmentModel.featureStates = featureStates;
    if (!!environmentJSON.identity_overrides) {
        environmentModel.identityOverrides = environmentJSON.identity_overrides.map(function (identityData) {
            return (0, util_2.buildIdentityModel)(identityData);
        });
    }
    return environmentModel;
}
exports.buildEnvironmentModel = buildEnvironmentModel;
function buildEnvironmentAPIKeyModel(apiKeyJSON) {
    var model = new models_1.EnvironmentAPIKeyModel(apiKeyJSON.id, apiKeyJSON.key, Date.parse(apiKeyJSON.created_at), apiKeyJSON.name, apiKeyJSON.client_api_key);
    return model;
}
exports.buildEnvironmentAPIKeyModel = buildEnvironmentAPIKeyModel;
